<agpr-take-over-panel
    [id]="'RecommendedRecipientPanel'"
    [splitHeader]="splitHeader"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    class="agpr-recommendedRecipientPanel-overlay"
    (visibleChange)="close()"
>
    <div
        class="agpr-recommendedRecipientPanel"
        [agprLoading]="loading && !initialLoading"
    >
        <div class="agpr-recommendedRecipientPanel-center">
            <!-- main content -->
            <ng-container *ngIf="!loading || !initialLoading">
                <div class="agpr-recommendedRecipientPanel-filterToolbar">
                    <div class="agpr-recommendedRecipientPanel-filterToolbar-filterInput">
                        <agpr-filter-dropdown
                            id="'recommendedRecipientPanel_filter'"
                            [showQuickFilter]="true"
                            quickFilterPlaceholder="Common.filterNameEmail.placeHolder"
                            [ariaLabel]="'Common.filterNameEmail.placeHolder' | localize"
                            [ariaDescribedBy]="'recommendedRecipientPanel_filter_chips'">
                        </agpr-filter-dropdown>
                        <agpr-filter-chips
                            [id]="'recommendedRecipientPanel_filter_chips'"
                        ></agpr-filter-chips>
                    </div>
                    <agpr-sort-order
                        id="recipientView-sortOrder"
                        [isDisabled]="!total"
                        tooltip="Discover.targeting.tooltips.sort"
                        optionKey="enumValue"
                        optionLabel="displayString"
                    >
                    </agpr-sort-order>
                </div>
                <div class="agpr-recommendedRecipientPanel-filterToolbar agpr-recommendedRecipientPanel-filterToolbar-bottom">
                    <agpr-checkbox
                        id="recommendedRecipientPanel_selectAll"
                        class="agpr-recommendedRecipientPanel-selectAll"
                        [binary]="true"
                        [ngModel]="results?.length > 0 && selectedResults?.length === results?.length"
                        (ngModelChange)="toggleSelectAll()"
                        [disabled]="!results?.length"
                        [label]="allSelected ? total : (selectedResults?.length || '0')"
                        hiddenLabel="selectAll"
                    ></agpr-checkbox>

                    <span class="agpr-recommendedRecipientPanel-totalCount">
                        <span class="agpr-recommendedRecipientPanel-totalCount-text">
                            {{ 'Paginator.of' | localize }}
                        </span>
                        <span class="agpr-recommendedRecipientPanel-totalCount-value">
                            {{ total }}
                        </span>
                        <span class="agpr-recommendedRecipientPanel-totalCount-text">
                            {{ 'Discover.recipientViewer.contacts' | localize }}
                        </span>
                    </span>

                    <agpr-paginator id="recipientView-paginator"></agpr-paginator>
                </div>

                <div
                    *ngIf="selectedResults?.length === results?.length && total > selectedResults?.length"
                    class="agpr-recommendedRecipientPanel-selectAllNotice"
                >
                    <agpr-message [severity]="messageSeverityEnum.info">
                        <span *ngIf="!allSelected">
                            {{ 'Discover.targeting.result.selectAll.notice.page' | localize : { count:selectedResults.length } }}
                        </span>
                        <span *ngIf="allSelected">
                            {{ 'Discover.targeting.result.selectAll.notice.all' | localize : { count:total } }}
                        </span>
                        <agpr-button
                            [id]="id + '.selectAll'"
                            *ngIf="!allSelected"
                            [label]="'Discover.targeting.result.selectAll.hyperlink.select' | localize : {
                                count: total
                            }"
                            (click)="selectAllResults()"
                            [style]="buttonTypes.link"
                            class="agpr-recommendedRecipientPanel-selectAllNotice-link"
                        ></agpr-button>
                        <agpr-button
                            [id]="id + '.clearSelectAll'"
                            *ngIf="allSelected"
                            label="Discover.targeting.result.selectAll.hyperlink.clear"
                            (click)="toggleSelectAll()"
                            [style]="buttonTypes.link"
                            class="agpr-recommendedRecipientPanel-selectAllNotice-link"
                        ></agpr-button>
                    </agpr-message>
                </div>
                <agpr-scroll-panel
                    *ngIf="results?.length"
                    class="agpr-recommendedRecipientPanel-scrollpanel"
                >
                    <ul
                        agprListKeyboardNavigation
                        [focusOnChild]="true"
                        [list]="results"
                        focusableElementCustomSelector=".agpr-recommendedRecipientPanel-card"
                    >
                        <li *ngFor="let result of results; let i = index; trackBy: trackResult">
                            <agpr-recommended-contact-card
                                [id]="'recommendedRecipientPanel_' + i + '_contactCard'"
                                [disableSelection]="allSelected"
                                [entity]="result"
                                [selectedResults]="selectedResults"
                                [searchModel]="searchModel"
                                [showBlueBadge]="isRecipientPartOfDistribution(result)"
                                [blueBadgeTooltip]="'Discover.recommendedRecipient.recipient.blueBadgeTooltip'"
                                [initiallyFocusable]="i === 0"
                                (focus)="cardFocused($event)"
                                (selectionChanged)="selectedResults = $event"
                                (showContactEditor)="contactEditorVisible = true"
                            >
                            </agpr-recommended-contact-card>
                        </li>
                    </ul>
                </agpr-scroll-panel>
                <div
                    *ngIf="!results?.length"
                    class="agpr-recommendedRecipientPanel-noRecipientsFound"
                >
                    <agpr-message
                        [severity]="messageSeverityEnum.noContent"
                    >
                        <span> {{ 'Discover.recommendedRecipients.noRecipientsFound' | localize }} </span>
                    </agpr-message>
                </div>
            </ng-container>

            <!-- placeholder loading -->
            <div
                *ngIf="loading && initialLoading"
                class="agpr-recommendedRecipientPanel-placeholder"
            >
                <div class="agpr-recommendedRecipientPanel-placeholder-text">
                    {{ 'Discover.recommendedRecipients.loadingText' | localize }}
                </div>
                <div class="agpr-recommendedRecipientPanel-placeholder-topBar">
                    <div class="agpr-recommendedRecipientPanel-placeholder-topBarLeft">
                        <div class="agpr-recommendedRecipientPanel-placeholder-skeleton1"></div>
                    </div>
                    <div class="agpr-recommendedRecipientPanel-placeholder-topBarRight">
                        <div class="agpr-recommendedRecipientPanel-placeholder-skeleton2"></div>
                    </div>
                </div>
                <div class="agpr-recommendedRecipientPanel-placeholder-bar">
                    <div class="agpr-recommendedRecipientPanel-placeholder-skeleton1"></div>
                </div>
                <div class="agpr-recommendedRecipientPanel-placeholder-card agpr-recommendedRecipientPanel-placeholder-opacity8">
                    <div class="agpr-recommendedRecipientPanel-placeholder-skeleton2"></div>
                </div>
                <div class="agpr-recommendedRecipientPanel-placeholder-card agpr-recommendedRecipientPanel-placeholder-opacity5">
                    <div class="agpr-recommendedRecipientPanel-placeholder-skeleton1"></div>
                </div>
                <div class="agpr-recommendedRecipientPanel-placeholder-card agpr-recommendedRecipientPanel-placeholder-opacity3">
                    <div class="agpr-recommendedRecipientPanel-placeholder-skeleton2"></div>
                </div>
                <div class="agpr-recommendedRecipientPanel-placeholder-card agpr-recommendedRecipientPanel-placeholder-opacity1">
                    <div class="agpr-recommendedRecipientPanel-placeholder-skeleton1"></div>
                </div>
            </div>
        </div>

        <!-- RHP sidebar -->
        <aside
            class="agpr-recommendedRecipientPanel-sidebar"
            [ngClass]="{
                'agpr-recommendedRecipientPanel-sidebar-shrink': ((!loading || !initialLoading) && (rhpSelectedTabIndex === 0))
            }"
        >
            <agpr-scroll-panel>
                <agpr-rhp-contexts
                    *ngIf="!loading || !initialLoading"
                    [id]="'recommendedRecipientPanel_rhp'"
                    [overlayContainer]="overlayContainer"
                    [disableContentToggle]="true"
                    [disableIfNoContactSelected]="true"
                    [contactSelected]="!!selectedContactId"
                    [showAiSearchSummary]="true"
                    [showFooter]="false"
                    (selectedTabIndexChange)="selectedTabIndexChange($event)"
                ></agpr-rhp-contexts>

                @if((!loading || !initialLoading) && (rhpSelectedTabIndex === 0)) {
                    <div class="agpr-recommendedRecipientPanel-sidebar-moreControl">
                        <div class="agpr-recommendedRecipientPanel-sidebar-moreControl-title">
                            {{ 'Discover.recommendedRecipients.actions.title' | localize }}
                        </div>
                        <ul>
                            <li>
                                {{ 'Discover.recommendedRecipients.actions.quickEdit.message' | localize }}
                                <agpr-button
                                    [label]="'Discover.recommendedRecipients.actions.quickEdit.link'"
                                    (click)="quickEdit()"
                                    [style]="buttonTypes.link"
                                >
                                </agpr-button>
                            </li>
                            <li>
                                {{ 'Discover.recommendedRecipients.actions.takeFindings.message' | localize }}
                                <agpr-button
                                    [label]="'Discover.recommendedRecipients.actions.takeFindings.link'"
                                    [ariaLabel]="'Discover.recommendedRecipients.actions.takeFindings.ariaLabel'"
                                    (click)="takeFindings()"
                                    [style]="buttonTypes.link"
                                >
                                    <span aria-hidden="true" class="fa-regular fa-arrow-up-rspanght-from-square"></span>
                                </agpr-button>
                            </li>
                        </ul>
                    </div>
                }
            </agpr-scroll-panel>

        </aside>
    </div>

    <ng-template
        *ngIf="!loading || !initialLoading"
        #takeOverFooterLeft>
        <agpr-button
            (click)="removeRecipients()"
            [disabled]="!recommendedRecipientListId || selectedResults.length === 0 || loading"
            label="Discover.recommendedRecipient.recipient.remove.button"
            [style]="buttonTypes.secondary"
            id="removeRecommendedRecipientsButton"
        ></agpr-button>

        <agpr-button
            class="agpr-recommendedRecipientPanel-addRecipient"
            [disabled]="loading || selectedResults?.length === 0"
            (click)="addRecipients()"
            label="Discover.recommendedRecipient.recipient.add.button"
            [style]="buttonTypes.primary"
            id="addRecommendedRecipientsButton"
        ></agpr-button>
    </ng-template>

    <ng-template
        *ngIf="!loading || !initialLoading"
        #takeOverFooterRight>
        <div class="agpr-recommendedRecipientPanel-contactsAdded">
            {{recipientCount ? recipientCount : '0'}} {{ 'Discover.recommendedRecipients.recipientsAdded' | localize }}
        </div>
        <agpr-button
            (click)="close()"
            label="done"
            [style]="buttonTypes.primaryB"
            id="doneButton"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
